import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Input from './Input';
import FileList from './FileList';
import { isUploadType } from './utils';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
function Upload(props) {
  var {
    uploadType = 'input'
  } = props;
  if (uploadType === 'input') {
    return /*#__PURE__*/_jsx(Input, _extends({}, props));
  }
  if (isUploadType(uploadType)) {
    return /*#__PURE__*/_jsx(FileList, _extends({}, props));
  }
  return null;
}
export default Upload;